import { useDeleteAssistantMutation } from "entities/languagesAssistants/mutations/mutateDeletingAssistant";

export const useDeleteAssistants = () => {
  const { mutate: deleteAssistant } = useDeleteAssistantMutation();

  const handleDeleteAssistants = async ({
    generalAssistantId,
    gameNameAssistantId,
  }: {
    generalAssistantId: string;
    gameNameAssistantId: string;
  }) => {
    await Promise.all([
      deleteAssistant(gameNameAssistantId),
      deleteAssistant(generalAssistantId),
    ]);
  };

  return { handleDeleteAssistants };
};
